export default __webpack_public_path__ + "c7621dd25230e28ee97553c9d1e12c39.png";